import React from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Button, 
  Typography
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

interface SessionTimeoutWarningProps {
  open: boolean;
  remainingSeconds: number;
  onStayLoggedIn: () => void;
  onLogout: () => void;
}

export const SessionTimeoutWarning: React.FC<SessionTimeoutWarningProps> = ({
  open,
  remainingSeconds,
  onStayLoggedIn,
  onLogout,
}) => {
  const seconds = remainingSeconds;

  return (
    <Dialog 
      open={open} 
      disableEscapeKeyDown
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderTop: 3,
          borderColor: 'warning.main',
        }
      }}
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <WarningAmberIcon color="warning" fontSize="large" />
        <span>Session Timeout Warning</span>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          You will be logged out in{' '}
          <strong style={{ fontSize: '1.2em', color: remainingSeconds <= 10 ? 'red' : 'inherit' }}>
            {seconds} second{seconds !== 1 ? 's' : ''}
          </strong>
          {' '}due to inactivity.
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          Click "Stay Logged In" to continue your session, or you will be automatically logged out to protect your account.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button 
          onClick={onLogout} 
          color="inherit"
          variant="outlined"
        >
          Logout Now
        </Button>
        <Button 
          onClick={onStayLoggedIn} 
          variant="contained" 
          color="primary"
          autoFocus
        >
          Stay Logged In
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionTimeoutWarning;
